import { OnboardingRequirementDto, OnboardingRequirementTypes } from "../../../models/onboarding-requirement";
import { bindable, bindingMode, autoinject } from 'aurelia-framework';
import { SecurityService } from "../../../services/security-service";
import { DialogService } from "aurelia-dialog";
import { BusyService } from "../../../services/busy-service";
import { WebApiService } from "../../../services/web-api-service";
import { CarrierRequirementDialog } from "../../dialogs/carrier-requirement-dialog/carrier-requirement-dialog";
import { CarrierRequirementExemptionDialog } from "../../dialogs/carrier-requirement-exemption-dialog/carrier-requirement-exemption-dialog";
import { CarrierRequirementExemptionDialogParams } from "../../dialogs/carrier-requirement-exemption-dialog/carrier-requirement-exemption-dialog-params";
import { UploadDocumentDialog } from "../../dialogs/upload-document-dialog";
import { LinkExistingDocumentDialog } from "./link-existing-document-dialog/link-existing-document-dialog";
import 'jquery';
import { SimpleDialog } from "../../dialogs/simple-dialog";
import { AppMessageService } from "../../../services/app-message-service";
import { UploadAndLinkDocumentDialog } from "../../dialogs/upload-and-link-document-dialog";

@autoinject()
export class OnboardingRequirementDetail {


    private static index = 0;
    public id: string = "";

    constructor(
        private dialogService: DialogService,
        private securityService: SecurityService,
        private api: WebApiService,
        private busyService: BusyService,
        private appMessageService: AppMessageService
    ) {
    }

    public attached() {
        if (this.req["isCategory"]) {
            this.id = "ID" + (this.req.name);
        } else {
            this.id = "ID" + OnboardingRequirementDetail.index++;
        }
        if (!this.loadCollapsed) {
            this.req.carrierMasterApprovalRequirementId
            setTimeout(() => {
                jQuery("#" + this.id).collapse("false");
            })
        }
    }

    @bindable()
    public userView: "CarrierService" | "Contracts & Insurance" | "ReadOnly" = undefined;
    @bindable()
    public readonly: boolean = true;
    @bindable()
    public loadCollapsed: boolean = true;
    @bindable()
    public req: OnboardingRequirementDto;
    @bindable()
    public carrierId: string = "none";
    @bindable()
    public carrierIntId: number = -1;
    @bindable()
    public carrierName: string = undefined;

    /** gets/sets whether a carrier services agent can clear rejection
 * Should only be true when displayed when the request is in the onboarding stage */
    @bindable()
    public carrierServicesCanClearRejection: boolean = false;


    @bindable openInsurance: Function;
    @bindable refresh: Function;

    @bindable
    public showOptionalRequirements = false;

    public onboardingRequirementTypes = OnboardingRequirementTypes;

    public approve(req: OnboardingRequirementDto) {
        this.setVerification(req, "Y");
    }
    public reject(req: OnboardingRequirementDto) {
        this.setVerification(req, "N");
    }

    public async markAsWaived(req: OnboardingRequirementDto) {
        var model = {
            title: "Waive Reason Required",
            message: "Please provide a comment to describe the reason for waiving this requirement:",
            showComment: true,
            comment: "",
            buttons: ["Save", "Cancel"]
        };

        const commentResult = await this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: model
            })
            .whenClosed((result) => {
                if (result.output == "Save") {
                    if (model.comment.trim().length >= 2) {
                        req.comment = model.comment;
                        return true;
                    } else {
                        alert("Valid Comment is Required");
                        return false;
                    }
                }
            });

        if (!commentResult) {
            return;
        }

        //mark as waived
        const params = {
            carrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId,
            comment: req.comment,
            isWaived: true
        }
        await this.api.post("Carriers", "UpdateMasterOnboardingRequirementWaived", params);
        this.refresh();
        this.appMessageService.addSuccessMessage("Requirement updated");
    }



    private async setVerification(req: OnboardingRequirementDto, status: "Y" | "N") {
        if (req.verifiedStatus == status) {
            this.clearVerification(req);
        } else {
            // comment required when attempting to verify an incomplete requirement
            if (!req.isComplete && status == "Y") {
                var model = {
                    title: "Override Reason Required",
                    message: "Please provide a comment to describe the reason for approving this incomplete requirement:",
                    showComment: true,
                    comment: "",
                    buttons: ["Save", "Cancel"]
                };

                const commentResult = await this.dialogService.open(
                    {
                        viewModel: SimpleDialog,
                        model: model
                    })
                    .whenClosed((result) => {
                        if (result.output == "Save") {
                            if (model.comment.trim().length > 10) {
                                req.comment = model.comment;
                                return true;
                            } else {
                                alert("Valid Comment is Required");
                                return false;
                            }
                        }
                    });

                if (!commentResult) {
                    return;
                }
            }
            req.verifiedByName = this.securityService.user.fullName;
            req.verifiedOn = new Date();
            req.verifiedStatus = status;
            const params = {
                carrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId,
                endorsementTypeId: req.endorsementTypeId,
                verifiedStatus: req.verifiedStatus,
                comment: req.comment
            }
            await this.api.post("Carriers", "UpdateMasterOnboardingRequirementVerificationStatus", params);
            this.appMessageService.addSuccessMessage("Verification updated");
        }
    }
    private async clearVerification(req: OnboardingRequirementDto) {
        var model = {
            title: "Remove Verification?",
            message: "Click OK to remove the verification from this requirement",
            showComment: false,
            comment: "",
            buttons: ["Ok", "Cancel"]
        };

        const answer = await this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: model
            })
            .whenClosed(async (result) => {
                if (result.output == "Ok") {
                    return true;
                }
            });

        if (!answer) {
            return;
        }

        req.verifiedByName = undefined;
        req.verifiedOn = undefined;
        if (req.isComplete) {
            req.verifiedStatus = "U";
        } else {
            req.verifiedStatus = undefined;
        }

        const params = {
            carrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId,
            clearStatus: true
        }
        await this.api.post("Carriers", "ClearMasterOnboardingRequirementVerificationStatus", params);
        this.appMessageService.addSuccessMessage("Verification removed");

    }

    public async addComment(req: OnboardingRequirementDto) {
        var model = {
            title: "Requirement Note",
            message: "Edit the note for this requirement:",
            showComment: true,
            comment: req.comment,
            buttons: ["Save", "Cancel"]
        };

        const answer = await this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: model
            })
            .whenClosed((result) => {
                if (result.output == "Save") {
                    req.comment = model.comment;
                    return true;
                }
            });

        if (answer) {
            const params = {
                carrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId,
                comment: req.comment
            }
            await this.api.post("Carriers", "UpdateMasterOnboardingRequirementComment", params);
            this.appMessageService.addSuccessMessage("Comment saved");
        }
    }


    public async showLinkExistingDocumentDialog(req) {
        let relatedRequirements = [];
        if (req.name.indexOf("Certificate") > -1) {
            relatedRequirements = await this.getRelatedRequirements(req);
        }
        const selectedRelatedRequirements = relatedRequirements.filter(o => o.carrierMasterApprovalRequirementId == req.carrierMasterApprovalRequirementId);
        this.dialogService.open(
            {
                viewModel: LinkExistingDocumentDialog,
                model: {
                    carrierIntId: this.carrierIntId,
                    carrierId: this.carrierId,
                    req: req,
                    relatedRequirements: relatedRequirements,
                    selectedRelatedRequirements: selectedRelatedRequirements
                }
            }).whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "UPLOAD") {
                        var reqs = result.output.reqs;
                        this.showUploadDocumentDialog(req);
                    } else {
                        this.refresh();
                    }
                }
            });
    }

    private async getRelatedRequirements(req) {
        const reqs: any[] = await this.getRelatedInsuranceRequirements(req.carrierMasterApprovalRequirementId);
        // if (reqs.length == 0) {
        //     reqs.push({
        //         name: req.name,
        //         carrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId
        //     }); 
        // }
        const filtered = reqs.filter(o => o.carrierMasterApprovalRequirementId != req.carrierMasterApprovalRequirementId);
        return filtered;
    }

    getRelatedInsuranceRequirements(carrierMasterApprovalRequirementId) {
        this.busyService.on();
        var params = { carrierRequirementId: carrierMasterApprovalRequirementId };
        return this.api.get("Carriers", "GetRelatedCarrierInsuranceRequirements", params)
            .then((result) => {
                const relatedRequirements: any[] = JSON.parse(result.response);
                return relatedRequirements;
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    public async removeCustomRequirement(req: OnboardingRequirementDto) {
        return this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: {
                    title: "Remove requirement?",
                    message: "Click Ok remove this requirement.",
                    buttons: ["Ok", "Cancel"]
                }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "Ok") {
                        this.busyService.on();
                        var params = { carrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId };
                        return this.api.post("Carriers", "RemoveCarrierMasterApprovalRequirement", params)
                            .finally(() => {
                                this.busyService.off();
                                this.refresh();
                            });
                    }
                }
            });
    }


    public async showUploadDocumentDialog(req) {
        let relatedRequirements = [];
        if (req.name.indexOf("Certificate") > -1) {
            relatedRequirements = await this.getRelatedRequirements(req);
        }
        const selectedRelatedRequirements = relatedRequirements.filter(o => o.carrierMasterApprovalRequirementId == req.carrierMasterApprovalRequirementId);
        this.dialogService.open({
            viewModel: UploadAndLinkDocumentDialog,
            model: {
                document: null,
                carrierName: this.carrierName,
                carrierId: this.carrierIntId,
                carrierGuid: this.carrierId,
                documentTypeIds: req.documentTypeIds.split(","),
                req: req,
                relatedRequirements: relatedRequirements,
                selectedRelatedRequirements: selectedRelatedRequirements
            }
        })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    var uploadResult = result.output;
                    const doc = uploadResult.document;
                    // Sort the versions array in descending order by version number
                    doc.versions.sort((a, b) => b.version - a.version);
                    
                    //const docVersion = doc.versions[0];

                    this.refresh();

                    // this.busyService.on();
                    // var params = { DocumentVersionId: docVersion.documentVersionId, CarrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId }
                    // return this.api.post("Carriers", "LinkOnboardingRequirementDocument", params)
                    //     .then((result) => {
                    //         this.refresh();
                    //     })
                    //     .finally(() => {
                    //         this.busyService.off();
                    //     });
                }
            });
    }

    // public unlink(req) {
    //     this.busyService.on();

    //     const reqIds = relatedRequirements.filter(o => o.carrierMasterApprovalRequirementId == req.carrierMasterApprovalRequirementId);

    //     var params = {
    //         DocumentVersionId: req.documentVersionId,
    //         CarrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId
    //     }
    //     return this.api.post("Carriers", "UnlinkOnboardingRequirementDocument", params)
    //         .finally(() => {
    //             this.refresh();
    //             this.busyService.off();
    //         });
    // }


    public addExemption(req: OnboardingRequirementDto) {
        this.dialogService.open(
            {
                viewModel: CarrierRequirementExemptionDialog,
                model: {
                    carrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId,
                    carrierId: this.carrierId,
                    carrierName: this.carrierName
                } as CarrierRequirementExemptionDialogParams
            }).whenClosed((result) => {
                if (!result.wasCancelled) {
                    this.refresh();
                }
            });
    }
    public async removeExemption(req: OnboardingRequirementDto) {
        //if (confirm("Do you want to remove this exemption?"))
        await this.api.post("Carriers", "RemoveRequirementExcemption", { carrierMasterApprovalRequirementId: req.carrierMasterApprovalRequirementId });
        this.refresh();
    }

}
